export default "TPE/PME : audit factures énergie gratuit, comparateur multi-fournisseurs (courtier indépendant des fournisseurs d'énergie), optimisation TURPE/ATRD, primes CEE tertiaires. Réponse sous 48 h.";
